import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    function onClick1() {
        this.handleClose();
    }
    function onClick2() {
        this.handleNoClick();
    }
    function onClick3() {
        this.handleYesClick();
    }
    return React.createElement('div', { 'className': 'fabricators-popup-container fabricators-popup-container--no-bg' }, React.createElement('div', { 'className': 'ui-popup ui-popup--question ' + this.props.questionPopupState.className }, React.createElement('button', {
        'className': 'ui-popup-header__close',
        'onClick': onClick1.bind(this)
    }), React.createElement('div', { 'className': 'ui-popup-body' }, this.props.questionPopupState.questionMessage), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
        'className': 'ui-button5 ui-button5--blue ui-button5--confirm',
        'onClick': onClick2.bind(this)
    }, 'No'), React.createElement('button', {
        'className': 'ui-button5 ui-button5--green ui-button5--confirm',
        'onClick': onClick3.bind(this)
    }, 'Yes'))));
}